import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@monbits/ui";
import type * as React from "react";
import { useNavigate } from "react-router-dom";
import { useMount } from "react-use";
import { toast } from "sonner";
import { Logo } from "src/components/logo";
import { TwoFactorVerification } from "src/components/two-factor";
import { useTwoFactor } from "src/hooks/use-two-factor";
import authProvider from "src/providers/auth-provider";

const OTPVerificationPage: React.FC = () => {
	const navigate = useNavigate();
	const { verifyTwoFactor, isSubmitting } = useTwoFactor();

	useMount(async () => {
		await authProvider.getCookie();
	});

	const handleVerify = async (code: string): Promise<boolean> => {
		const success = await verifyTwoFactor(code);
		if (success) {
			navigate("/", {
				state: { reloadUserInfo: true },
			});
			toast.success("Authentication successful", {
				description: "Welcome back!",
			});
		}
		return success;
	};

	const handleCancel = () => {
		navigate("/login");
	};

	return (
		<div className="min-h-screen flex items-center justify-center p-4">
			<div className="w-full max-w-md">
				<div className="flex justify-center mb-8">
					<Logo variant="full" size="xl" />
				</div>

				<Card>
					<CardHeader>
						<CardTitle>Two-Factor Authentication</CardTitle>
						<CardDescription>
							Enter the code from your authenticator app to continue
						</CardDescription>
					</CardHeader>
					<CardContent>
						<TwoFactorVerification
							onVerify={handleVerify}
							onCancel={handleCancel}
							isSubmitting={isSubmitting}
							showBackupOption={true}
							description="Enter the 6-digit code from your authenticator app"
						/>
					</CardContent>
				</Card>
			</div>
		</div>
	);
};

export default OTPVerificationPage;
